<template>
  <div class="div" v-loading="loading">
    <!-- <div class="title">资产信息</div> -->
    <div class="div-top">
      <span>截止日期：</span>
      <el-date-picker
        v-model="searchData.eDate"
        type="date"
        placeholder="选择截止日期"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      <el-input
        v-model="searchData.Keyword"
        clearable
        placeholder="请输入备件名称或编号"
        style="width: 300px; margin-left: 10px"
      ></el-input>

      <el-button type="primary" @click="handleSearch" style="margin-left: 10px"
        >查询</el-button
      >
      <el-button
        type="warning"
        @click="handleExport"
        style="margin-left: 10px"
        icon="el-icon-download"
        >导出数据</el-button
      >
    </div>
    <div class="div-center">
      <el-table
        :data="tableData"
        ref="table"
        style="width: 100%"
        height="calc(100% - 40px)"
      >
        <el-table-column label="序号" width="50" type="index">
        </el-table-column>

        <el-table-column
          label="备件编号"
          align="center"
          prop="MaterialCode"
          sortable
        ></el-table-column>
        <el-table-column
          label="备件名称"
          align="center"
          prop="MaterialName"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="备件类别"
          align="center"
          prop="MaterialType"
          sortable
        >
        </el-table-column>
        <el-table-column label="备件规格" align="center" prop="Spec" sortable>
        </el-table-column>

        <el-table-column label="结存数量" align="center" prop="tQty" sortable>
        </el-table-column>
      </el-table>
      <div
        style="
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: right;
        "
      >
        <el-pagination
          style="margin-top: 10px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.PageIndex"
          :page-sizes="pagination.PageSizes"
          :page-size="pagination.PageRows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'
import tools from '@/utils/tools.js'
export default {
  data() {
    return {
      moment,
      searchData: {
        eDate: '',
        Keyword: '',
      },

      tableData: [],

      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
    }
  },
  props: {},
  components: {},
  methods: {
    handleExport() {
      if (!this.searchData.eDate) {
        return this.$notify.warning('请选择日期后导出')
      }
      tools.download(
        this.$rootUrl +
          `/PB/PB_Material/ExportBalanceToExcel?Keyword=${this.searchData.Keyword}&Type=${this.FittingsTreeSearch}&eDate=${this.searchData.eDate}`,
        '备件结存',
        '.xlsx',
        'get'
      )
    },
    FittingsChange(arr) {
      console.log(arr)
      this.searchData.MaterialId = arr[0].Id
      this.MaterialName = arr[0].Name
      this.MaterialCode = arr[0].Code
    },
    handleSelect(selection) {
      this.selectedRows = selection
    },

    addList() {
      this.$refs.Fittings.openDialog()
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/PB/PB_Material/GetInventoryBalanceData', {
          PageIndex: 1,
          PageRows: 20,
          SortField: 'Id',
          SortType: 'desc',
          Search: {
            ...this.searchData,
            Type: this.FittingsTreeSearch,
          },
        })
        .then((resJson) => {
          this.loading = false
          this.tableData = resJson.Data
          this.pagination.total = resJson.Total
        })
    },
    handleSearch() {
      console.log(this.rDate)
      if (!this.searchData.eDate) {
        return this.$notify.warning('请选择日期后查询')
      }
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
  },
  mounted() {},
  created() {},
  computed: {
    ...mapState(['FittingsTreeSearch']),
  },
  watch: {
    FittingsTreeSearch() {
      this.handleSearch()
    },
  },
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 30px);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
</style>
